import { create } from "zustand";
import type { ReportDraft } from "./voice-report";

/** Private draft shared between WEB branches; never persisted to browser storage. */
export const useReportDraft = create<{
  drafts: Record<string, ReportDraft>;
  save: (key: string, draft: ReportDraft) => void;
  clear: (key: string) => void;
}>((set) => ({
  drafts: {},
  save: (key, draft) =>
    set((state) => ({ drafts: { ...state.drafts, [key]: draft } })),
  clear: (key) =>
    set((state) => {
      const drafts = { ...state.drafts };
      delete drafts[key];
      return { drafts };
    }),
}));
